import styled, { css } from 'vue-styled-components';

import { GRAY } from '@styles/common.styled';
import { FLEX_VERTICAL_CENTER_DIV } from '@styles/common.styled.component';

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: right;
    padding: 12px 15px;

    button {
        padding: 9px 16px;
        height: 36px;
        font-size: 13px;
        font-weight: 500;
        margin-left: 10px;

        &.white {
            /* border: none; */
        }
    }
`;

export const OptionItem = styled('li', { maxWidth: Number, isBlocked: Boolean })`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 9px 15px;
    cursor: pointer;
    ${({ isBlocked }) =>
        isBlocked &&
        css`
            opacity: 0.3;
            cursor: not-allowed;
        `}

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .checkbox-wrapper {
        min-width: 16px;
        min-height: 16px;

        .text {
            font-size: 13px;
            font-weight: normal;
            color: ${GRAY(100)};
            overflow: hidden;
            text-overflow: ellipsis;
            margin-left: 8px;
            max-width: ${({ maxWidth }) =>
                maxWidth ? `${maxWidth - 60}px` : '250px'};
            white-space: nowrap;
        }
    }
`;

export const KeywordActionWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    hasResults: Boolean,
    maxWidth: Number,
})`
    color: ${GRAY(100)};
    padding: 9px 16px;
    font-size: 13px;
    cursor: pointer;

    border-bottom: ${({ hasResults }) =>
        hasResults ? `1px solid ${GRAY(25)}` : 'unset'};

    & .keyword {
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '200px')};
        margin-right: 6px;
    }

    & .suffix {
        min-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
